module.exports = __webpack_public_path__ + "static/media/Athelas-Italic.5116c0f0.woff";